let parameters = {
    template: {
        label: 'Template',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'code',
        value: '',
        display: false,
        wait: false,
        lang: 'html',
    },
    stylesheet: {
        label: 'Style',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'code',
        value: '',
        display: false,
        wait: false,
        lang: 'css',
    },
    javascript: {
        label: 'Javascript',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'code',
        value: '',
        lang: 'javascript',
        display: false,
        wait: false
    }
};

export default parameters;
